import { render, staticRenderFns } from "./EditOrderitemMaterialVariantInProductManagement.vue?vue&type=template&id=1751abd8&scoped=true"
import script from "./EditOrderitemMaterialVariantInProductManagement.vue?vue&type=script&lang=js"
export * from "./EditOrderitemMaterialVariantInProductManagement.vue?vue&type=script&lang=js"
import style0 from "./EditOrderitemMaterialVariantInProductManagement.vue?vue&type=style&index=0&id=1751abd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1751abd8",
  null
  
)

export default component.exports